"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var useStyles = (0, core_1.makeStyles)(function (_theme) {
    return (0, core_1.createStyles)({
        spinner: {
            display: 'inline-block',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateY(-50%) translateX(-50%)',
            zIndex: 9999,
            i: {
                fontSize: '120px',
                color: 'rgba(51,51,51,.8)'
            }
        },
        spinnerFrame: {
            position: 'fixed',
            left: '0;top:0;right:0;bottom:0',
            backgroundColor: function (_a) {
                var transition = _a.transition;
                return transition ? 'rgba(232,228,218,1)' : 'rgba(111,111,111,.6)';
            },
            zIndex: function (_a) {
                var transition = _a.transition;
                return transition ? 9999 : 10000;
            }
        }
    });
});
var Spinner = function (_a) {
    var type = _a.type;
    var styles = useStyles({ transition: type === 'transition' });
    return (react_1.default.createElement("div", { className: styles.spinnerFrame + ' spinnerFrame', "aria-label": "Spinner Frame" },
        react_1.default.createElement("div", { className: styles.spinner },
            react_1.default.createElement("i", { className: 'fa fa-spinner fa-pulse fa-5x fa-fw' }))));
};
Spinner.propTypes = {
    type: prop_types_1.default.string
};
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map